import React, { useState, useEffect, useRef } from "react";
import { TextField, Button, Grid, Paper, MenuItem, Box, Typography } from "@mui/material";
import AuthService from "../../Auth/AuthService";


const form3 = [
  { label: 'Study Medium', name: 'medium', req: true, holder: 'Enter study medium' },
  { label: 'Academic Year', name: 'academicYear', req: true, holder: 'Enter academic year' },
  { label: 'Standard/Class', name: 'standard', req: true },
  { label: 'Section', name: 'section', req: true, holder: 'Enter study section' },
  { label: 'Annual Fee', name: 'annualFee', type: 'number', req: false, holder: 'Enter annual fee' },
  { label: 'Transport/Travel Fees', name: 'vehicleFee', req: false, holder: 'Enter school Bus fees' },
  { label: 'Pattern Type', name: 'patternType', req: true, holder: 'Enter STATE/CBSC..' },
  { label: 'Promotion Date', name: 'promotionDate', type: 'date', req: false },
  { label: 'Student Type', name: 'studentType', req: true, holder: 'stdtype RTE/NON_RTE' },
  { label: 'Roll Number', name: 'rollNumber', req: true, holder: 'Enter roll number' },
];
export default function ClassRoomForm({ initialData, onSubmit }) {
  const [formData, setFormData] = useState({
    studentId: "",
    marksheetId: "",
    standard: "",
    section: "",
    academicYear: "",
    annualfee: "",
    vehicleFee: 0,
    patternType: "",
    promotionDate: "",
    admissionDate: "",
    rollNumber: "",
    studentType: "",
  });
  const [feesStructures, setFeesStructures] = useState([]);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (initialData) setFormData(initialData);
    fetchFeesStructures();
  }, [initialData]);

  const fetchFeesStructures = async () => {
    try {
      const url = AuthService.pathUrl('GET', "/fees/structure");
      const response = await AuthService.getAuth(url);
      setFeesStructures(response);
    } catch (error) {
      console.error("Error fetching fees structures:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    if (name === "standard") {
      const selectedData = feesStructures.find((f) => f.standard === value);
      setFormData((prev) => ({
        ...prev,
        standard: value,
        annualFee: selectedData ? selectedData.annualFee : "",
        vehicleFee: selectedData ? selectedData.vehicleFee : "",
      }))
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFormSection(form3)) return;
    onSubmit(formData);
  };

  const regex = {
    pattern: /^(STATE|CBSE|ICSE)$/i ,    // allowed options
    type: /^(RTE|NON_RTE)$/i ,
    academicyear: /^2\d{3}-2\d{3}$/  // matches 2000-2999 only
  };

  const validateFormSection = (formFields) => {
    for (let field of formFields) {
      if (field.req) {
        const value = formData[field.name];
        if (!value || value.toString().trim() === '') {
          setError(`Please fill out the "${field.label}" field.`);
          return false;
        }
        if (field.name === "patternType" && value && !regex.pattern.test(value)) {
          setError("Please enter pattern type (STATE, CBSE, ICSE).");
          return false;
        }
        if (field.name === "studentType" && value && !regex.type.test(value)) {
          setError("Please enter student type (RTE, NON_RTE).");
          return false;
        }

        if (field.name === "academicYear" && value && !regex.academicyear.test(value)) {
          setError("Please enter academic year (2024-2025).");
          return false;
        }
      }
    }
    setError(null);
    return true;
  };

  const renderClassForm = (formFields) => (
    <Grid display="flex" justifyContent="center" flexWrap="wrap">
      {formFields.map(({ label, name, type = 'text', req = true, holder }) => (
        <Grid item xs={12} sm={6} sx={{ width: '40%', m: 2 }} key={name}>
          <TextField
            select={name === 'standard' ? true : false}
            fullWidth
            required={req}
            variant="outlined"
            label={label}
            name={name}
            placeholder={holder}
            value={formData[name]}
            onChange={handleChange}
            type={type}
            slotProps={type === 'date' && {
              inputLabel: { shrink: true }
            }}
          >
            {name === 'standard' &&
              feesStructures.map((fee) => (
                <MenuItem key={fee.id} value={fee.standard}>
                  {fee.standard}-{fee.branch}
                </MenuItem>
              ))}

          </TextField>
        </Grid>
      ))}
      <Typography sx={{ fontSize: '10px', color: 'red' }}>{error}</Typography>
    </Grid>
  );

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        {renderClassForm(form3)}
        <Grid item xs={12} sm={6}>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 5, bgcolor: '#1b1914', borderRadius: 5 }}>
            {initialData.classId ? "Update" : "submit"}
          </Button>
        </Grid>
      </form>
    </Box>
  );
}
